import { isOwnerSupportGhost } from "../../../utils/isOwnerSupportGhost.js";

const isRealAccountUser = (user) =>
  Boolean(user) && user.isDeleted !== true && !isOwnerSupportGhost(user);

/**
 * User shown on an owner-table row. Ghosts are removed first. Then the first
 * real advertiser wins. If the only advertiser was the ghost, the fallback is
 * the first real adsUsers child in key order (the array order from RTDB).
 * Returns null when every user is a ghost or deleted. isHidden does not
 * remove a real user.
 */
export const getPrimaryAdvertiserUser = (users) => {
  if (!Array.isArray(users)) {
    return null;
  }

  const realUsers = users.filter(isRealAccountUser);
  return (
    realUsers.find((user) => user.role === "advertiser") || realUsers[0] || null
  );
};

export const getAdvertiserUserSubtitle = (users, searchMatchedEmail = null) => {
  const advertiserUser = getPrimaryAdvertiserUser(users);
  const matchedEmail =
    typeof searchMatchedEmail === "string" &&
    !isOwnerSupportGhost(searchMatchedEmail)
      ? searchMatchedEmail
      : null;
  const email = matchedEmail || advertiserUser?.email;

  if (advertiserUser?.name && email) {
    return `${advertiserUser.name}/${email}`;
  }

  return email || advertiserUser?.name || null;
};
